import { render, staticRenderFns } from "./ButtonGeneral.vue?vue&type=template&id=1f181f1c&scoped=true&lang=pug&"
import script from "./ButtonGeneral.vue?vue&type=script&lang=ts&"
export * from "./ButtonGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonGeneral.vue?vue&type=style&index=0&id=1f181f1c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f181f1c",
  null
  
)

export default component.exports